export default {
    methods: {
        /**
         * Return if the user have the ability to do the request.
         */
        authorize(ability) {
            return window.config.authorize && window.config.authorize.includes(ability);
        },
    },
}
